// extracted by mini-css-extract-plugin
export var box = "sub-section-module--box--jqK8b";
export var container1 = "sub-section-module--container1--ee5-Z";
export var container3 = "sub-section-module--container3--Qmdy1";
export var headerTitle = "sub-section-module--header-title--q-2Ka";
export var headingDiv = "sub-section-module--heading-div--hq1Fg";
export var smallTitleClass = "sub-section-module--small-title-class--KnoaE";
export var subTitleClass = "sub-section-module--sub-title-class--3vkyL";